// services/countries.js — списъкът с държави (config/countries.config.json)
// за формата на контакта.
//
// Обвивката съществува по същата причина като services/siddo.js: Vite
// (екранът) и чист Node ESM (jsdom тестовете) искат import-атрибут за JSON,
// а CJS require го чете навсякъде без церемонии. Екранът внася ТОЗИ модул,
// не JSON-а направо. Сървърът (routes/contacts.js) си чете файла сам.

const config = require('../config/countries.config.json');

module.exports = {
  countries: config.countries,
  meta: config._meta,
};
